import { MonitorIoTClass } from "@/services/backend/qpm/types/enums";

export type DerivedIoTDependentsResult = {
  requiredSimAmount: number;
  requiredPortalAmount: number;
};

export function accumulateDerivedIoTDependents(
  current: DerivedIoTDependentsResult,
  iotClass: MonitorIoTClass,
  amount: number,
): DerivedIoTDependentsResult {
  const { requiredSimAmount, requiredPortalAmount } = current;

  if (iotClass === MonitorIoTClass.IoTGateway) {
    return {
      requiredSimAmount: requiredSimAmount + amount,
      requiredPortalAmount,
    };
  }

  if (iotClass === MonitorIoTClass.IoTPestMonitorWithSim) {
    return {
      requiredSimAmount: requiredSimAmount + amount,
      requiredPortalAmount: requiredPortalAmount + amount,
    };
  }

  if (
    iotClass === MonitorIoTClass.IoTSensor ||
    iotClass === MonitorIoTClass.IoTPestMonitor
  ) {
    return {
      requiredSimAmount,
      requiredPortalAmount: requiredPortalAmount + amount,
    };
  }

  return current;
}

export function getDerivedIoTDependents(): DerivedIoTDependentsResult {
  return {
    requiredSimAmount: 0,
    requiredPortalAmount: 0,
  };
}

export function supportsIoTCheckpointService(
  iotClass?: MonitorIoTClass,
): boolean {
  return (
    iotClass === MonitorIoTClass.IoTPestMonitor ||
    iotClass === MonitorIoTClass.IoTPestMonitorWithSim
  );
}
